import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "question-container" }
const _hoisted_2 = { class: "question" }
const _hoisted_3 = { class: "options-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "option-label" }
const _hoisted_6 = { class: "option-value" }

import { DefineProps } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Question',
  props: ["question"],
  emits: ["selectOption"],
  setup(__props, { emit: __emit }) {

const emitSelectedOption = (isCorrect: boolean) => {
  return emit("selectOption", isCorrect);
};
const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.question.text), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "option",
          key: option.id,
          onClick: ($event: any) => (emitSelectedOption(option.isCorrect))
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(option.label), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(option.text), 1)
          ])
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})